/** Halo marketing site — matches Squarespace-exposed settings */
export const CONTACT_EMAIL = 'hello@halocompliance.com'

export const CONTACT_MAILTO_URL = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Demo request')}&body=${encodeURIComponent('Hi Halo,\n\nI’d love to see a demo.\n\nName:\nCompany:\nPhone:')}`

export const SOCIAL = {
  facebook: 'https://www.facebook.com/profile.php?id=61579350543658',
  linkedin: 'https://www.linkedin.com/company/halocompliance/',
} as const
